const AuthPermissions = currentUser => {
  const userCanSeeCommission = findRule(currentUser, "RULE_OFFICER_VIEW_COMMISSION");
  const userCanApproveOrReject = findRule(currentUser, "RULE_WORKFLOW_APPROVE_DILIGENCE");
  const canArchive = findRule(currentUser, "RULE_OFFICER_CAN_ARCHIVE");
  const canViewPendingQuotes = findRule(currentUser, "RULE_OFFICER_USER_CAN_VIEW_PENDING_QUOTES");
  const canCreateTradeFromQuote = findRule(currentUser, "RULE_OFFICER_USER_CAN_CREATE_TRADE_FROM_QUOTE");
  const canEditQuotePrice = findRule(currentUser, "RULE_OFFICER_USER_CAN_EDIT_QUOTE_PRICE");
  const canViewCommissionDetail = findRule(currentUser, "RULE_OFFICER_USER_CAN_VIEW_COMMISSION_DETAIL");
  const userCanEditSpecialProjectCommission = findRule(currentUser, "RULE_OFFICER_CAN_EDIT_SPECIAL_PROJECT_COMMISSION");
  const canPrecifyByOtherPartner = findRule(currentUser, "RULE_CAN_PRECIFY_BY_OTHER_PARTNER");

  return {
    userCanSeeCommission,
    userCanApproveOrReject,
    canArchive,
    canViewPendingQuotes,
    canCreateTradeFromQuote,
    canEditQuotePrice,
    canViewCommissionDetail,
    userCanEditSpecialProjectCommission,
    canPrecifyByOtherPartner
  };
};

function findRule(user, ruleToSearch: string): boolean {
  let hasRule = false;

  if (user.profiles) {
    user.profiles.forEach(profile => {
      if (profile.rules.find(rule => rule.name === ruleToSearch)) {
        hasRule = true;
      }
    });
  }
  if(!hasRule && user.rules.find(rule => rule.name === ruleToSearch)){
    hasRule = true;
  }
  return hasRule;
}

export default AuthPermissions;



// WEBPACK FOOTER //
// ./src/services/middleware/AuthPermission.ts